import React, { useState, useEffect, useRef } from "react";
import { useThrottle } from "../hooks/useThrottle";
import Loading from "../Loading";
import "./InfiniteScroller.scss";

const InfiniteScroller = ({
  useInfiniteScroll,
  numItems,
  rowHeight,
  tableHeight,
  batchSize,
  fetchBuffer,
  handleFetchData,
  shouldResetState,
  setShouldResetState,
  children,
}) => {
  const ref = useRef();
  const [scrollTop, setScrollTop] = useState(0);
  const [lowerBound, setLowerBound] = useState(batchSize);
  const [loading, setLoading] = useState(false);

  useThrottle(
    async () => {
      let endIndex = Math.min(
        numItems - 1, // Don't render items out of list's scope
        Math.floor((scrollTop + tableHeight) / rowHeight)
      );

      if (endIndex > lowerBound - fetchBuffer) {
        setLoading(true);
        await handleFetchData(lowerBound, batchSize);
        setLowerBound((oldLowerBound) => oldLowerBound + batchSize);
        setLoading(false);
      }
    },
    150,
    [scrollTop]
  );

  const handleScroll = (event) => {
    if (!loading) {
      setScrollTop(event.currentTarget.scrollTop);
    }
  };

  useEffect(() => {
    if (shouldResetState) {
      setScrollTop(0);
      setLowerBound(batchSize);
      setShouldResetState(false);
      if (ref && ref.current) {
        const { y } = ref.current.getBoundingClientRect();
        ref.current.scrollTo(y, 0);
      }
    }
  }, [shouldResetState, batchSize, setShouldResetState]);

  return (
    <>
      {useInfiniteScroll ? (
        <div
          className="ak-parent-container"
          style={{ overflowY: "scroll", height: tableHeight }}
          onScroll={handleScroll}
          ref={ref}
        >
          <div
            className="ak-loading-overlay"
            style={{
              height: ref && ref.current && ref.current.clientHeight,
              width: ref && ref.current && ref.current.clientWidth,
              display: loading ? "flex" : "none",
            }}
          >
            <Loading style={{ margin: 0 }} />
          </div>
          <div style={{ position: "relative" }}>{children}</div>
        </div>
      ) : (
        <div className="ak-parent-container">{children}</div>
      )}
    </>
  );
};

export default InfiniteScroller;
